import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { uniqBy, } from "lodash";
import { GetEmployeeApi, UpdateEmployeeStatusApi } from "./employeeAction";
import { setHeading } from "../../../accounts/account.actions";
import { baseURL, headers } from "../../../../../global/api";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import BlockIcon from '@mui/icons-material/Block';
import moment from "moment";
import MaterialTable from 'material-table';


const ViewEmployee = (props) => {
    const tableRef = useRef();
    function updateTableQuery() {
        tableRef.current.onQueryChange()
    };

    useEffect(() => {
        props.setHeading("Employees List")
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    tableRef={tableRef}
                    title="Employees List"
                    columns={uniqBy([
                        { title: 'Sr. No', field: 'sequenceNumber', editable: 'never' },
                        { title: 'Image', field: 'uploadImage', editable: 'never', render: rowData => <img src={`${baseURL}/assets/${rowData.uploadImage}`} alt='img' style={{ width: 30, borderRadius: '50%' }} /> },
                        { title: 'Department', field: 'departmentDetails.department', editable: 'never' },
                        { title: 'Designation', field: 'designationDetails.designation', editable: 'never' },
                        { title: 'Name', field: 'employeeName' },
                        { title: 'Father Name', field: 'fatherName' },
                        { title: 'CNIC', field: 'cnic' },
                        { title: 'LT Adv', field: 'ltAdv', editable: 'never' },
                        { title: 'ST Adv', field: 'stAdv', editable: 'never' },
                        { title: 'Date Of Birth', field: 'dob', render: rowData => moment(rowData.dob).format('DD-MM-YYYY') },
                        { title: 'Joining Date', field: 'joiningDate', render: rowData => moment(rowData.joiningDate).format('DD-MM-YYYY') },
                        { title: 'Employee Type', field: 'employeeTypeDetails.employeeType', editable: 'never' },
                        {
                            title: "Active Status", field: "activeStatus",
                            render: (rowData) => (
                                <div
                                    style={{
                                        backgroundColor: rowData.activeStatus === true ? "#9FD983" : rowData.activeStatus === false ? "#F8B8A2" : "#f7cb74",
                                        padding: "5px 16px 7px",
                                        borderRadius: "10px",
                                        textAlign: "center",
                                        width: "max-content"
                                    }}
                                >
                                    {rowData.activeStatus === true ? 'Active' : 'Blocked'}
                                </div>
                            ),
                        },
                        { title: 'Created At', field: 'createdAt', render: rowData => moment(rowData.createdAt).format('DD-MM-YYYY') },
                    ], 'title')}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/employee?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + query.page;
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    detailPanel={rowData => {
                        return (
                            <MaterialTable
                                columns={[
                                    { title: 'Machine Id', field: 'machineId' },
                                    { title: 'Basic Salary', field: 'basicSalary' },
                                    { title: 'Medicial Allowance', field: 'medicialAllowance' },
                                    { title: 'Petrol Allowance', field: 'petrolAllowance' },
                                    { title: 'Accomodation Allowance', field: 'accomodationAllowance' },
                                    { title: 'Special Allowance', field: 'specialAllowance' },
                                    { title: 'Total Allowances', field: 'totalAllowances' },
                                    { title: 'Total Salary', field: 'totalSalary' },
                                ]}
                                data={[rowData.salary]}
                                options={{
                                    actionsColumnIndex: -1,
                                    toolbar: false,
                                    exportButton: true,
                                    sorting: true,
                                    paging: false,
                                    pageSize: 30,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: 'sticky', top: 0,
                                        color: '#00BBBB',
                                        fontWeight: '550',
                                        onRowAdd: 'none',
                                    }
                                }}
                            />
                        )
                    }}
                    options={{
                        actionsColumnIndex: -1,
                        filtering: false,
                        exportButton: true,
                        exportAllData: true,
                        sorting: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200, 500],
                        headerStyle: {
                            position: 'sticky', top: 0,
                            color: '#00BBBB',
                            fontWeight: '550',
                            onRowAdd: 'none',
                        },
                    }}
                    editable={{
                        isEditable: rowData => false,
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    if (oldData) {
                                        props.HRUpdateEmployee(newData, oldData)

                                    }
                                }, 600);
                            }),
                        // isDeletable: rowData => false,
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    // props.deleteHR(oldData._id, updateTableQuery);
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                        (rowData) => ({
                            disabled: rowData.activeStatus === false ? false : true,
                            icon: () => <TaskAltIcon style={{ color: rowData.activeStatus === false ? 'green' : '#cccccc' }} />,
                            tooltip: "Active",
                            onClick: (event, rowData) => {
                                const status = true
                                props.UpdateEmployeeStatusApi(status, rowData._id);
                                tableRef.current && tableRef.current.onQueryChange();
                            },
                        }),
                        (rowData) => ({
                            disabled: rowData.activeStatus === true ? false : true,
                            icon: () => <BlockIcon style={{ color: rowData.activeStatus === true ? '#dc3545' : '#cccccc' }} />,
                            tooltip: "Blocked",
                            onClick: (event, rowData) => {
                                const status = false
                                props.UpdateEmployeeStatusApi(status, rowData._id);
                                tableRef.current && tableRef.current.onQueryChange();
                            },
                        }),
                    ]}
                />
            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        UpdateEmployeeStatusApi: (status, id) => dispatch(UpdateEmployeeStatusApi(status, id)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmployee);